/**
 * RukuNaSrce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UserRoleEnum = 1 | 2 | 3;

export const UserRoleEnum = {
    SystemAdministrator: 1 as UserRoleEnum,
    Administrator: 2 as UserRoleEnum,
    User: 3 as UserRoleEnum
};

